import classNames from 'classnames';
import styles from './styles.module.scss';

type TabContentWrapperPropsType = {
  children;
  setMargin?: boolean;
  contentHeightFull?: boolean;
  contentHeight?: number | string;
  absoluteChild?;
  overflowHidden?: boolean;
};

const TabContentWrapper = (props: TabContentWrapperPropsType) => {
  const { children, setMargin, contentHeightFull, contentHeight, absoluteChild, overflowHidden } =
    props;

  return (
    <div
      className={classNames(
        styles.wrapper,
        { [styles.wrapperMargin]: setMargin },
        { [styles.wrapperHidden]: overflowHidden },
        { [styles.wrapperAbsolute]: !!absoluteChild },
      )}
      id="profile-tab-content-wrapper"
    >
      {absoluteChild}
      <div
        className={classNames(
          styles.content,
          { [styles.contentHidden]: overflowHidden },
          { [styles.contentHeight]: contentHeightFull && !contentHeight },
          { [styles.contentMargin]: !!absoluteChild },
        )}
        style={
          !contentHeightFull && contentHeight
            ? {
                height: contentHeight,
              }
            : {}
        }
      >
        {children}
      </div>
    </div>
  );
};

export default TabContentWrapper;
